// Microsoft Clarity project ID is a public-facing identifier (shipped in client JS regardless of where it's stored),
// so we hardcode it here. The previous attempt to thread it through Vite's env-var pipeline (VITE_CLARITY_ID) didn't
// reach Vite at build time in the Dokploy deployment; rather than keep debugging that, the value is inlined.
// Trade-off: disabling Clarity per-environment now requires a code change.
//
// CONSENT: this module no longer decides *whether* Clarity may run. The consent
// registry (corelib/consent) calls init() only once the visitor has granted the
// 'marketing' category — Clarity pings Bing UET for session correlation, which
// is an advertising identifier, so it is categorised as marketing rather than
// analytics. The MODE check below is a separate concern: it keeps dev builds
// free of tracking regardless of consent.
const CLARITY_PROJECT_ID = 'qzjh9f95d5';

function shouldInit() {
  return import.meta.env.MODE === 'production';
}

function init() {
  if (!shouldInit()) {
    return;
  }
  console.info(`Init | Microsoft Clarity - ${CLARITY_PROJECT_ID}`);
  (function(c, l, a, r, i, t, y) {
    c[a] = c[a] || function() {
      (c[a].q = c[a].q || []).push(arguments);
    };
    t = l.createElement(r);
    t.async = 1;
    t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  }(window, document, 'clarity', 'script', CLARITY_PROJECT_ID));
}

export { init, shouldInit };
